import { render, staticRenderFns } from "./NnnFooter.vue?vue&type=template&id=055f9fd5&scoped=true&"
import script from "./NnnFooter.vue?vue&type=script&lang=ts&"
export * from "./NnnFooter.vue?vue&type=script&lang=ts&"
import style0 from "./NnnFooter.vue?vue&type=style&index=0&id=055f9fd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055f9fd5",
  null
  
)

export default component.exports